// array_to_color_dict.jsx
import { biomesColorsDict } from '../static/colors/biomeColors';
import * as d3 from 'd3';


function rgbToHex(r, g, b) {
  return (
    '#' +
    [r, g, b]
      .map((x) => {
        const hex = Math.round(x).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      })
      .join('')
  );
}


export default function arrayToColorDict(colorsData, scatterColorCategory) {
  if (!colorsData || colorsData.length === 0) {
    return [[], {}, []];
  }

  const categoriesSet = Array.from(new Set(colorsData));
  const maxVal = categoriesSet.length;
  const ColorDict = {};

  const categoryColorMap = {
    "Freshwater": [0, 130, 200],        // Blue color for freshwater
    "Oceanic": [0, 0, 128],             // Navy color for oceans
    "Fecal": [128, 0, 0],               // Brown/maroon for fecal matter
    "Digestive System": [170, 110, 40], // Brown color for digestive system
    "Oral": [250, 190, 212],            // Pink color for oral cavity
    "Vaginal": [240, 50, 230],          // Magenta/purple for vaginal
    "Animal": [225, 225, 25],           // yellow for animal sources
    "Mixed": [128, 128, 128],           // Gray for mixed sources
    "Terrestrial": [60, 180, 75],       // Green for terrestrial/earth
    "Skin": [230, 25, 75]               // Red for skin
  };
  // const categoryColorMap = {
  //   "Freshwater": [128, 128, 128],        // Blue color for freshwater
  //   "Oceanic": [128, 128, 128],             // Navy color for oceans
  //   "Fecal": [128, 128, 128],               // Brown/maroon for fecal matter
  //   "Digestive System": [128, 128, 128], // Brown color for digestive system
  //   "Oral": [128, 128, 128],            // Pink color for oral cavity
  //   "Vaginal": [128, 128, 128],          // Magenta/purple for vaginal
  //   "Animal": [128, 128, 128],           // yellow for animal sources
  //   "Mixed": [128, 128, 128],           // Gray for mixed sources
  //   "Terrestrial": [128, 128, 128],       // Green for terrestrial/earth
  //   "Skin": [128, 128, 128]               // Red for skin
  // };

  let interpolator;

  if (scatterColorCategory === "source_biome_clustered") {
    categoriesSet.forEach((category) => {
      if (categoryColorMap[category]) {
        ColorDict[category] = categoryColorMap[category];
      } else {
        ColorDict[category] = [170, 170, 170];
      }
    });
  } else if (scatterColorCategory === "source_biome") {
    interpolator = d3.interpolateYlOrRd;
    categoriesSet.forEach((category, i) => {
      let rgb = interpolator(i / (maxVal));
      const result = rgb.match(/\d+/g);
      let rgb_int = result.map(num => parseInt(num));
      ColorDict[category] = rgb_int;
    });
  } else if (scatterColorCategory === "instrument_model") {
    // https://d3js.org/d3-scale-chromatic/diverging
    // interpolator = d3.interpolateYlGn;
    // interpolator = d3.interpolateSpectral;
    interpolator = (t) => {
      const cycleCount = 21;
      const adjustedT = (t * cycleCount) % 1;
      return d3.interpolateTurbo(adjustedT);
    };
    // interpolator = d3.interpolateRdYlGn;
    categoriesSet.forEach((category, i) => {
      let rgb = interpolator(i / (maxVal));
      const result = rgb.match(/\d+/g);
      let rgb_int = result.map(num => parseInt(num));
      ColorDict[category] = rgb_int;
    });
  } else if (scatterColorCategory === "geographic_location") {
    interpolator = d3.interpolateRdPu;
    categoriesSet.forEach((category, i) => {
      let rgb = interpolator(i / (maxVal));
      const result = rgb.match(/\d+/g);
      let rgb_int = result.map(num => parseInt(num));
      ColorDict[category] = rgb_int;
    });
  } else if (scatterColorCategory === "environment_material") {
    interpolator = d3.interpolateCubehelix.gamma(3)("purple", "orange");
    categoriesSet.forEach((category, i) => {
      let rgb = interpolator(i / (maxVal));
      const result = rgb.match(/\d+/g);
      let rgb_int = result.map(num => parseInt(num));
      ColorDict[category] = rgb_int;
    });
  } else {
    // interpolator = (t) => {
    //   const cycleCount = 1003;
    //   const adjustedT = (t * cycleCount) % 1;
    //   return d3.interpolateTurbo(adjustedT);
    // };
    interpolator = d3.interpolateRdPu;
    categoriesSet.forEach((category, i) => {
      let rgb = interpolator(i / (maxVal));
      const result = rgb.match(/\d+/g);
      let rgb_int = result.map(num => parseInt(num));
      ColorDict[category] = rgb_int;
    });
  }

  ColorDict["__user__"] = [128, 0, 128]; // purple for user points

  console.log(ColorDict);

  const categoryToIndex = categoriesSet.reduce((acc, category, index) => {
    acc[category] = index;
    return acc;
  }, {});

  const userColorIndex = Object.keys(categoryToIndex).length;

  const colorsIndexList = colorsData.map(category => categoryToIndex[category]);

  return [categoriesSet, ColorDict, colorsIndexList, userColorIndex];
}